<template>
  <ypo-concierge-wrapper>
    <v-layout class="ypo-concierge-floater">
      <v-btn v-if="conciergeCollapse && !isConciergeActive" @click="conciergeCollapse = false" class="ypo-concierge-floater__button-collapsed">
        <icon-ypo-concierge height="30" width="30"></icon-ypo-concierge></v-btn>
      <v-speed-dial
          v-if="!conciergeCollapse"
          v-model="ypoConciergeHelpInitiated"
          :bottom="buttonConfig.bottom"
          :direction="buttonConfig.direction"
          :left="buttonConfig.left"
          :open-on-hover="buttonConfig.hover"
          :right="buttonConfig.right"
          :top="buttonConfig.top"
          :transition="buttonConfig.transition"
      >
        <template v-slot:activator>
          <v-btn
              v-if="!isConciergeActive"
              v-model="ypoConciergeHelpInitiated"
              class="ypo-concierge-floater__button-main"
              dark
              fab
          >
            <v-flex class="ypo-concierge-floater__button-label">
                <icon-ypo-concierge height="30" width="30"></icon-ypo-concierge>
                <div class="ypo-concierge-floater__button-title">{{ ypoConciergeConstant.CONCIERGE }}</div>
            </v-flex>
          </v-btn>
        </template>
        <ypo-concierge-layout v-if="!isConciergeActive" :handle-ypo-concierge-help-initiated="setYpoConciergeHelpInitiated"></ypo-concierge-layout>
      </v-speed-dial>
      <v-btn class="ypo-concierge-floater__button-close"
             v-if="!conciergeCollapse && !ypoConciergeHelpInitiated && !isConciergeActive"
             @click="conciergeCollapse = true" >
        <v-icon color="black" size="16">close</v-icon>
      </v-btn>
    </v-layout>
  </ypo-concierge-wrapper>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { trackEventConstant } from "@/plugins/analytics.constant";
import { storeGetters } from "@/store/storeGetters.constant";
import StatusOverlay from "@/components/StatusOverlay/StatusOverlay";
import { ypoConciergeConstant } from "./ypoConcierge.constant";
import IconYpoConcierge from "../Icons/IconYpoConcierge";
import YpoConciergeLayout from "@/components/YpoConcierge/YpoConciergeLayout.vue";
import YpoConciergeWrapper from "@/components/YpoConcierge/YpoConciergeWrapper.vue";

export default {
  name: 'YpoConciergeFloater',
  components: { YpoConciergeWrapper, YpoConciergeLayout, StatusOverlay, IconYpoConcierge },
  data() {
    return {
      ypoConciergeConstant,
      trackEventConstant,
      ypoConciergeHelpInitiated: false,
      chatInitializationInProgress: false,
      conciergeCollapse: false,
      buttonConfig: {
        direction: 'top',
        transition: 'slide-y-reverse-transition',
      },
      requestAssistanceLink: process.env.VUE_APP_YPO_SF_ASSISTANCE_URL || "",
    };
  },
  methods: {
    setYpoConciergeHelpInitiated(val) {
      this.ypoConciergeHelpInitiated = val;
    },
  },
  computed: {
    ...mapState('actionState', ['actions']),
    ...mapGetters({
      isYpoConciergeAgentAvailable: `ypoConciergeService/${storeGetters.isYpoConciergeAgentAvailable}`,
      conciergeScriptLoaded: `ypoConciergeService/${storeGetters.isConciergeScriptLoaded}`,
      isConciergeActive: `ypoConciergeService/${storeGetters.isConciergeActive}`,
      profileInformation: `myAccount/${storeGetters.profileInformation}`,
      routeConfigHideConcierge: storeGetters.routeConfigHideConcierge,
    }),
    displayConcierge() {
      return !this.routeConfigHideConcierge && this.profileInformation && this.profileInformation.recordTypeName
          && ypoConciergeConstant.rolesWithAccessToConcierge.includes(this.profileInformation.recordTypeName);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../common/styles/_colors.scss';
@import '../../common/styles/_commonClasses.scss';
@import '../../common/styles/_responsive.scss';

.ypo-concierge-floater {
  position: fixed;
  right: 10px;
  bottom: 55px;

  @include breakpoint(sm) {
    bottom: 70px;
    right: 10px;
  }

  .ypo-concierge-layout {
    position: fixed;
    right: 20px;
    bottom: 130px;

    @include breakpoint(sm) {
      bottom: 140px;
    }
  }

  &__button-main {
    background-color: $ypo-brand-blue !important;
    border-radius: 30px;
    width: 155px;
    justify-content: center;
  }
  &__button-label {
    justify-content: center;
    align-items: center;
    display: flex;
  }
  &__button-collapsed {
    border-radius: 50%;
    width: 55px;
    min-width: 55px;
    height: 55px;
    justify-content: center;
    align-items: center;
    display: flex;
    background-color: $ypo-brand-blue !important;
  }
  &__button-close {
    position: absolute;
    top: -13px;
    right: 0;
  }

  &__button-title {
    font-size: 16px;
    padding-left: 5px;
    font-weight: 600;
    text-transform: none;
  }

  &__concierge-close {
    color: $white;
  }
}
</style>

<style lang="scss">
@import '../../common/styles/_colors.scss';
.ypo-concierge-floater {

  &__button-main {
    height: 50px;
    margin: 0 6px 0 0 !important;
  }

  &__button-close {
    height: 18px !important;
    width: 18px !important;
    min-width: 18px !important;
    padding: 3px !important;
    border-radius: 50%;
    background-color: $ypo-cta-light !important;
  }
}
</style>
